import React from 'react';
import {useTranslation} from 'react-i18next';
import { motion } from 'framer-motion';
import { fadeInUp, fadeInLeft, fadeInRight, staggerContainer, staggerItem, buttonVariants } from '../../utility/framerMotionAnimations';

const HeroSection = ({ onScrollToForm }) => {
    const { t } = useTranslation('homepage');
    return (
        <section className='hero-section'>
            <div className='hero-content'>
                <div className="hero-section-one">
                    <motion.div 
                        className="glass-container"
                        initial="hidden"
                        animate="visible"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                        variants={fadeInLeft}
                    >
                        <motion.div className="glass-container-content">
                            <motion.h1 
                                variants={fadeInUp}
                            >
                                {t('hero-section-title')}
                            </motion.h1>
                            <motion.h2 
                                variants={fadeInUp}
                                transition={{ delay: 0.2 }}
                            >
                                {t('hero-section-title-description')}
                            </motion.h2>
                            <motion.button 
                                className="btn-big btn-primary" 
                                onClick={onScrollToForm}
                                variants={buttonVariants}
                                whileHover="hover"
                                whileTap="tap"
                                transition={{ delay: 0.4 }}
                            >
                                {t('hero-section-button')}
                            </motion.button>
                        </motion.div>
                    </motion.div>
                    <motion.div 
                        className="glass-container-right"
                        initial="hidden"
                        animate="visible"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                        variants={fadeInRight}
                    ></motion.div>
                </div>
                <div className="hero-section-two">
                    <div className="hero-features">
                        <motion.div 
                            className="container"
                            variants={staggerContainer}
                            initial="hidden"
                            animate="visible"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                        >
                                <motion.div 
                                    className="col-md-4 align-center border-right"
                                    variants={staggerItem}
                                >
                                    <div className="hero-feature">
                                        <h3>🚀 {t('hero-feature-section-title1')}</h3>
                                        <p>{t('hero-feature-section-description1.line1')}<br/>{t('hero-feature-section-description1.line2')}</p>
                                    </div>
                                </motion.div>
                                <motion.div 
                                    className="col-md-4 align-center border-right"
                                    variants={staggerItem}
                                >
                                    <div className="hero-feature">
                                        <h3>📞 24/7 {t('hero-feature-section-title2')}</h3>
                                        <p>{t('hero-feature-section-description2.line1')}<br/>{t('hero-feature-section-description2.line2')}</p>
                                    </div>
                                </motion.div>
                                <motion.div 
                                    className="col-md-4 align-center border-right"
                                    variants={staggerItem}
                                >
                                    <div className="hero-feature">
                                        <h3>🎯 {t('hero-feature-section-title3')}</h3>
                                        <p>{t('hero-feature-section-description3.line1')}<br/>{t('hero-feature-section-description3.line2')}</p>
                                    </div>
                                </motion.div>
                                <motion.div 
                                    className="col-md-4 align-center"
                                    variants={staggerItem}
                                >
                                    <div className="hero-feature">
                                        <h3>💼 {t('hero-feature-section-title4')}</h3>
                                        <p>{t('hero-feature-section-description4.line1')}<br/>{t('hero-feature-section-description4.line2')}</p>
                                    </div>
                                </motion.div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroSection;